import { Analysis, DashboardConfigurationDependencies, Granularity } from '../../../../dashboard-config/dashboard-config.model';
import { DashboardFilter } from '../../../../filters/dashboard_filter';
import {
  DashboardDistrictSingleSelectFilter,
  DashboardRemoteStateSingleSelectFilter,
  DashboardStateSingleSelectFilter,
  DashboardSubMarketSingleSelectFilter,
  DashboardSubMarketsMultiSelectFilter,
  DashboardWzClassesMultiSelectFilter,
} from '../../../../filters/dashboard_filter_implementations';

export const INDEX_RANKING_DEVELOPMENT_SHELL_ID =
  'index-ranking-development' as const;

export type DashboardIndexRankingDevelopmentShell = 'subMarkets' | 'wzClasses' | 'districtSubMarkets';

/** UI control kind for the chart-row year filter (`year_bar_chart`). */
export type YearBarChartFilterKind = 'yearSlider' | 'yearSelect';

export interface DashboardIndexRankingDevelopmentShellProfile {
  id: typeof INDEX_RANKING_DEVELOPMENT_SHELL_ID;
  granularityId: Granularity;
  analysisId: Analysis;
  /** Default control kind for chart-row year filter `year_bar_chart`. */
  yearBarChartKind: YearBarChartFilterKind;
  /** Default span for line-chart years filter `years_line_chart`. */
  yearsLineChartDefaultRange: number;
  buildGranularityFilters: (
    deps: DashboardConfigurationDependencies,
    options?: {
      addSumGermany?: boolean;
      excludeSumSubMarkets?: boolean;
    },
  ) => DashboardFilter<any>[];
}

export const dashboardIndexRankingDevelopmentShellProfiles: Record<DashboardIndexRankingDevelopmentShell, DashboardIndexRankingDevelopmentShellProfile> = {
  subMarkets: {
    id: INDEX_RANKING_DEVELOPMENT_SHELL_ID,
    granularityId: Granularity.SubMarkets,
    analysisId: Analysis.Index,
    yearBarChartKind: 'yearSlider',
    yearsLineChartDefaultRange: 5,
    buildGranularityFilters: (deps, options) => [
      new DashboardStateSingleSelectFilter(deps.localDatasetsService, {
        addSumGermany: options?.addSumGermany ?? true,
      }),
      new DashboardSubMarketsMultiSelectFilter(deps.localDatasetsService, {}),
    ],
  },
  districtSubMarkets: {
    id: INDEX_RANKING_DEVELOPMENT_SHELL_ID,
    granularityId: Granularity.DistrictSubMarkets,
    analysisId: Analysis.Index,
    yearBarChartKind: 'yearSlider',
    yearsLineChartDefaultRange: 5,
    buildGranularityFilters: (deps, options) => [
      new DashboardRemoteStateSingleSelectFilter(deps.localDatasetsService, {
        addSumGermany: false,
      }),
      new DashboardDistrictSingleSelectFilter(deps.localDatasetsService, {
        autoDisplayFirst: true,
      }),
      new DashboardSubMarketsMultiSelectFilter(deps.localDatasetsService, {}),
    ],
  },
  wzClasses: {
    id: INDEX_RANKING_DEVELOPMENT_SHELL_ID,
    granularityId: Granularity.WzClasses,
    analysisId: Analysis.Index,
    yearBarChartKind: 'yearSelect',
    yearsLineChartDefaultRange: 2,
    buildGranularityFilters: (deps, options) => [
      new DashboardStateSingleSelectFilter(deps.localDatasetsService, {
        addSumGermany: options?.addSumGermany ?? true,
      }),
      new DashboardSubMarketSingleSelectFilter(deps.localDatasetsService, {
        ...(options?.excludeSumSubMarkets
          ? { excluded: deps.sumSubMarketIds }
          : {}),
      }),
      new DashboardWzClassesMultiSelectFilter(deps.localDatasetsService, {}),
    ],
  },
};
